<template>
    <div
        class="inline-flex justify-center w-full px-2 py-4 rounded-full text-sm font-medium hover:bg-gray-stroke transition"
    >
        <IconDots />
    </div>
</template>
